var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useUploadManager } from '../UploadManagerProvider';
import { UploadFailedError } from '../errors/UploadFailedError';
import { DeleteFailedError } from '../errors/DeleteFailedError';
import { AssetStatusType, } from '@design-stack-ct/assets-sdk';
import { useCallback } from 'react';
/**
 * Hook that returns the upload and delete functions & the asset store.
 */
export const useFileMethods = () => {
    const { assetStore, assetsExpireOn, onError, onUploadCompleted, assetDeleted, folderIdForShopper, folderName } = useUploadManager();
    const uploadFile = useCallback((uploadData, options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            let uploadParams;
            if (typeof uploadData === 'string') {
                uploadParams = {
                    uri: uploadData,
                };
            }
            else {
                uploadParams = { file: uploadData };
            }
            uploadParams = Object.assign(Object.assign({}, uploadParams), { expires: assetsExpireOn, info: { asset: { hidden: (options === null || options === void 0 ? void 0 : options.hidden) || false } }, properties: options === null || options === void 0 ? void 0 : options.properties });
            if (folderIdForShopper) {
                uploadParams.folderId = folderIdForShopper;
            }
            let asset;
            // We need to check for the type because upload has at least two different signatures
            if ('file' in uploadParams) {
                asset = yield assetStore.upload(uploadParams);
            }
            else {
                asset = yield assetStore.upload(uploadParams);
            }
            yield asset.presign();
            if (((_a = asset === null || asset === void 0 ? void 0 : asset.status) === null || _a === void 0 ? void 0 : _a.type) === AssetStatusType.Error) {
                throw (_b = asset === null || asset === void 0 ? void 0 : asset.status) === null || _b === void 0 ? void 0 : _b.rawError;
            }
            onUploadCompleted === null || onUploadCompleted === void 0 ? void 0 : onUploadCompleted(asset);
            return asset;
        }
        catch (err) {
            let fileName;
            if (typeof uploadData === 'string') {
                fileName = uploadData;
            }
            else {
                fileName = uploadData.name;
            }
            const error = new UploadFailedError(`Failed to upload asset ${fileName ? fileName : null}${folderIdForShopper ? ` to ${folderIdForShopper}` : ''}: ${err}`, uploadData);
            if (onError) {
                return onError(error);
            }
            else {
                throw error;
            }
        }
    }), [assetStore, assetsExpireOn, folderIdForShopper, onError, onUploadCompleted]);
    const deleteFile = useCallback((asset) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        try {
            if (asset.isDamAsset()) {
                yield asset.hide();
            }
            else {
                yield asset.delete(folderName ? { ownerId: folderName } : undefined);
            }
            assetDeleted(asset);
        }
        catch (err) {
            const error = new DeleteFailedError(`Failed to delete asset ${(_c = asset.data) === null || _c === void 0 ? void 0 : _c.id}: ${err}`);
            if (onError) {
                return onError(error);
            }
            else {
                throw error;
            }
        }
    }), [assetDeleted, folderName, onError]);
    return {
        uploadFile,
        deleteFile,
        assetStore,
    };
};
//# sourceMappingURL=useFileMethods.js.map